module.exports = __webpack_public_path__ + "media/newstyle/images/icon-check-red-b186e96144e986cd734c930ad28142ab.svg";